import React from 'react';
import uniq from 'lodash/uniq';

import { UiButton } from 'src/components/UI/Button';

type Props = {
  errorMessages: string[];
};

export const ListErrors: React.FC<Props> = ({ errorMessages }) => (
  <ul>
    {uniq(errorMessages).map((message) => (
      <li key={message}>{message}</li>
    ))}
  </ul>
);

/** common modal errors */

type PropsClose = {
  data: string[];
  onClose?: () => void;
};

export const ValidationListErrors: React.FC<PropsClose> = ({ data, onClose }: PropsClose) =>
  data.length ? (
    <div className="alert alert-danger validationReport">
      {onClose && (
        <UiButton tag="a" className="close" onClick={onClose}>
          ×
        </UiButton>
      )}
      <ListErrors errorMessages={data} />
    </div>
  ) : null;
